module.exports = __webpack_public_path__ + "img/bg-1.efd36104.png";